import { render } from "./PreviewImage.vue?vue&type=template&id=08a0a962&scoped=true"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"

import "./PreviewImage.vue?vue&type=style&index=0&id=08a0a962&lang=scss&scoped=true"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a0a962"]])

export default __exports__